module.exports = __webpack_public_path__ + "static/media/fitness.66c7cd92.png";